'use strict';
module.exports = require('./Editor.vue');